<script>
import VTextFieldDatePicker from "@/components/commonComponents/VTextFieldDatePicker.vue";
import _ from "lodash";

export default {
    name: "VDataTableCustomHeaderFiltersDate",
    inheritAttrs: false,
    components: {
        VTextFieldDatePicker,
    },
    props: {
        header: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
        },
        items: {
            type: Array,
        },
    },
    computed: {
        itemsValues() {
            return _(this.items)
                .map(item => this.$moment(_.get(item, this.header.value)))
                .value();
        },
        minDate() {
            return this.$moment.min(this.itemsValues).toISOString();
        },
        maxDate() {
            return this.$moment.max(this.itemsValues).toISOString();
        },
    },
    methods: {
        filterItems(items) {
            if (!this.value) {
                return items;
            }
            const filterValue = this.$moment(this.value),
                headerValue = this.header.value;
            return _.filter(items, (item) => {
                const value = _.get(item, headerValue);
                return filterValue.isSame(value, 'day');
            });
        },
    },
}
</script>

<template>
    <v-text-field-date-picker
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        :label="header?.text"
        :min="minDate"
        :max="maxDate"
        human-format="DD.MM.YY"
        prepend-icon=""
        clearable
        hide-details
        single-line
        class="mb-4"
        dense
    ></v-text-field-date-picker>
</template>

<style scoped lang="scss">

</style>
